// extracted by mini-css-extract-plugin
export default {"main":"PCSelect_main__xU4QF","pcselect":"PCSelect_pcselect__tnt3e"};